import React from 'react';
import { token } from '@atlaskit/tokens';
import { N0, N800 } from '@atlaskit/theme/colors';

import type { ColorRole } from './types';
import AccentIcon from './components/accent-icon';

export const COLOR_ROLES: ColorRole[] = [
  {
    name: 'neutral',
    description:
      'Use for default text and secondary UI elements, such as secondary buttons or navigation elements.',
    token: token('color.icon', '#8993A5'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'brand',
    description:
      'Use for primary actions or elements that communicate the Atlassian brand.',
    token: token('color.background.brand.bold', '#0C66E4'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },

  {
    name: 'information',
    description:
      'Use for informative UI, such as an information icon, or UI that communicates something is in progress.',
    token: token('color.background.information.bold', '#0C66E4'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'success',
    description:
      'Use to communicate a favorable outcome, such as a success message.',
    token: token('color.background.success.bold', '#1F845A'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'warning',
    description:
      'Use for UI that communicates caution to prevent a mistake or error from occurring.',
    token: token('color.background.warning.bold', '#E2B203'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'danger',
    description:
      'Use for UI that communicates danger or serious error states. ',
    token: token('color.background.danger.bold', '#CA3521'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'discovery',
    description:
      'Use for UI that communicates something new, such as onboarding or new feature information.',
    token: token('color.background.discovery.bold', '#6E5DC6'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'accent',
    description: `Use for colors that don't have any specific meaning tied to them. You should be able to exchange one accent color for another, and the experience would remain unchanged.
    
    Accent colors: red, green, blue, yellow, orange, teal, purple, and magenta.
      `,
    icon: <AccentIcon />,
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
  },
  {
    name: 'inverse',
    description:
      'Use for UI that communicates something new, such as onboarding or new feature information.',
    token: token('color.icon.inverse', N0),
    background: token('color.background.neutral.bold', N800),
    inverse: true,
  },
  {
    name: 'input',
    description:
      'Use for form fields. (Note that design system form fields will already have tokens applied.)',
    token: token('color.border.input', 'rgba(9, 30, 66, 0.14)'),
    background: token('color.background.neutral', 'rgba(9, 30, 66, 0.06)'),
    input: true,
  },
];
